<template>
  <div class="pages" v-if="userInfo">
    <div
      class="bigMask"
      draggable="true"
      @dragenter="dragenter($event)"
      @dragleave="dragleave($event)"
      @dragover="dragover($event)"
      @drop="drop($event)"
      ref="drop"
      v-if="dropShow && !loading"
    >
      <p>释放即可上传</p>
      <input type="file" multiple ref="input1" @change="imgUpload($event)" />
    </div>

    <headers @openVideo="openVideo" :tipStatus="tipStatus" class="headerPo" />
    <!-- main -->
    <div class="main">
      <!-- 两个view -->
      <div class="twoView" v-if="viewStatus">
        <div class="localFile blockView" v-if="false">
          <div class="titleTwo">
            <p>本地文件夹</p>
          </div>
          <div class="fileList" v-if="localList.length == 0">
            <div class="listNull">
              <div class="fakeInput">
                <img src="../../assets/img/folderIcon.svg" alt />
                选择图片所在目录
              </div>
              <p>点击添加一个要上传的图片所在目录</p>
            </div>
          </div>
          <div class="fileData" v-if="localList.length != 0">
            <div class="title">
              <template v-if="allDataUn[0].length != 0">
                <div class="tabList">
                  <div
                    class="tabItem"
                    :class="checkNav == index ? 'check' : ''"
                    v-for="(item, index) in allDataUn[0]"
                    :key="index"
                    @click="clickNav(index)"
                  >
                    {{ item.title }}
                    <img src="../../assets/img/tabCloseW.svg" alt />
                  </div>
                </div>
              </template>
              <template v-else>
                <div></div>
              </template>
            </div>
            <div class="projectDir">
              <p>
                当前目录：
                <span @click="checkHome">首页</span>
                <span
                  v-for="(item, index) in navArr"
                  :key="index"
                  @click="returnUp(index)"
                  >>{{ item }}</span
                >
              </p>
            </div>
            <div class="projectList">
              <input
                v-if="showLocalArr.length == 0"
                type="file"
                webkitdirectory
                multiple
                @change.self="addProList($event)"
              />

              <template v-if="!preTrue">
                <div
                  class="projectItem"
                  v-for="(item, index) in showLocalArr"
                  :key="index"
                  @click="checkImg(index)"
                  @dblclick="dblCheckImg(item, index)"
                >
                  <!-- 文件夹 -->
                  <template v-if="item.dir == 1">
                    <div
                      class="fileIcon"
                      :style="
                        item.check == 1 ? 'background:rgb(160,197,223)' : ''
                      "
                    >
                      <img src="../../assets/img/folder.svg" alt />
                    </div>
                  </template>

                  <!-- 图片 -->
                  <template v-else-if="item.dir == 0">
                    <div class="posi">
                      <img
                        src="../../assets/img/imgCheck.svg"
                        alt
                        v-if="item.check == 1"
                        class="iconCheck"
                      />
                      <img
                        src="../../assets/img/imgNoCheck.svg"
                        alt
                        v-else
                        class="iconCheck"
                      />
                      <img
                        :src="item.imgUrl"
                        alt
                        class="imgType"
                        @load="imgLoad(item)"
                      />
                      <div class="loadDiv" v-if="item.loading != 1">
                        加载中...
                      </div>
                    </div>
                  </template>

                  <!-- 其他类型的文件 -->
                  <template v-else-if="item.dir == -1">
                    <div class="fileIcon">
                      <img src="../../assets/img/other.svg" alt />
                    </div>
                  </template>

                  <p>{{ item.title }}</p>
                </div>

                <div class="projectItem" v-if="addFileStatus">
                  <div class="addImgBtn">
                    <input
                      type="file"
                      webkitdirectory
                      multiple
                      @change="addProList($event)"
                    />
                    <img src="../../assets/img/addImg.png" alt />
                  </div>
                </div>
              </template>

              <template v-if="preTrue">
                <div
                  class="projectItem"
                  v-for="(item, index) in imgListArr"
                  :key="index"
                >
                  <div class="posi">
                    <img
                      src="../../assets/img/imgCheck.svg"
                      alt
                      v-if="item.check == 1"
                      class="iconCheck"
                      @click="checkClick(index)"
                    />
                    <img
                      src="../../assets/img/imgNoCheck.svg"
                      alt
                      v-else
                      class="iconCheck"
                      @click="checkClick(index)"
                    />
                    <img
                      :src="item.imgUrl"
                      alt
                      class="imgType"
                      @load="imgLoad(item)"
                    />
                    <div class="loadDiv" v-if="item.loading != 1">
                      加载中...
                    </div>
                  </div>
                  <p>{{ item.title }}</p>
                </div>
              </template>
            </div>
            <div class="thumbnailTab" @click="previewTab">
              <div v-if="preTrue">
                <img src="../../assets/img/closeEyes.svg" alt />
                关闭缩略图
              </div>
              <div v-else>
                <img src="../../assets/img/imgIcon.svg" alt />
                一键预览缩略图
              </div>
            </div>
          </div>
        </div>

        <div class="cloudFile blockView">

          <div class="titleTwo" v-if="false">
            <!-- <p>将电脑中的精选作品批量上传至云作品，目前支持JPG\TIFF\BMP\PNG\GIF\WEBP\HELF格式。</p> -->
            <div class="addBtn">
              <span>添加图片</span>
              <input
                type="file"
                multiple
                ref="input1"
                @change="imgUpload($event)"
              />
            </div>
          </div>
          <div v-if="userInfo.is_expire == 0">
            <div class="fileList" v-if="upDownArr.length == 0">
              <div class="listNull">
                <img
                  src="../../assets/img/q2.svg"
                  alt
                  class="imgIcon"
                  ondragstart="return false;"
                />
                <div class="propaganda">
                  <p class="oneTitle">批量拽入图片</p>
                  <p class="oneTitle1">分隔为多个作品后同步至小程序</p>
                  <!-- <p>支持JPG\TIFF\BMP\PNG\GIF\WEBP\HELF格式，</p> -->
                  <p style="color: rgb(0, 0, 0, 0.6);">推荐使用chrome浏览器</p>
                  <p style="color: rgb(0, 0, 0, 0.6);">每次同步图片不建议超过100张</p>
                </div>

                <div class="addBtn">
                  <span>点击添加或拖拽</span>
                  <input
                    type="file"
                    multiple
                    ref="input1"
                    @change="imgUpload($event)"
                  />
                </div>
              </div>
            </div>

            <!-- @update="datadragEnd" -->
            <div class="div12" v-else>
              <draggable
                v-model="upDownArr"
                @start="datadragStart"
                :move="datadragMove"
                @end="datadragEnd"
                :options="{ animation: 500 }"
                class="upFileData"
                id="content"
                ref="getElement"
              >
                <!-- v-bind:style="{height:maskHeight + 'px'}" -->
                <!-- @mouseenter="imgMobile ? '' : enter(index)" -->

                <!-- @click="openSwiper(index)" -->
                <div
                  class="upLoadItem"
                  v-for="(item, index) in upDownArr"
                  @mouseenter="enter(index)" 
                  @mouseleave="leave()"
                  @mousedown="setMove(true)"
                  @click="openSwiper(index)"
                  :key="index"
                >
                  <div class="upLoadImg" :class="imgMobile ? 'upLoadItem_bg1' : ''">
                    <img
                      src="../../assets/img/deleteIcon.svg"
                      alt
                      class="closeIcon"
                      v-if="!imgMobile"
                      v-show="item.deleteC && !isNotShowBg"
                      @mouseenter="deleteEnter(index)"
                      @click.stop="deleteImg(index)"
                    />
                    <!-- @click="openSwiper(index)" -->
                    <img v-if="(!imgMobile || (imgMobile && index != mobileIndex))"
                      :src="item.qiniu"
                      alt
                      class="image"
                      @dblclick="breakUp(index)"
                      @load="qiniuImgLoad(item)"
                      @error="imgError(item)"
                    />
                    <div v-else class="image-e"></div>
                    <!-- !imgMobile && -->
                    <div 
                      class="imgHalfMask"
                      v-if=" 
                        item.upLoadStatus == 1 &&
                        !item.move &&
                        item.projectName != ''
                      "
                    >
                      <img
                        src="../../assets/img/rightJ.svg"
                        v-if="item.break == 1 && item.projectName"
                        alt
                        class="right"
                      />
                      <p class="name">{{ item.projectName }}</p>
                    </div>

                    <div
                      class="maskImgerr"
                      v-else-if="item.upLoadStatus == 0"
                      @click.stop="againUp"
                    >
                      <img
                        src="../../assets/img/errIcon.svg"
                        alt
                        class="errIcon"
                      />
                      <p>点击重传</p>
                    </div>
                  
                    <div 
                      class="maskImgIng"
                      @mouseenter="deleteEnter(index)"
                      v-else-if="item.upLoadStatus == -1"
                    >
                      <!-- <el-progress
                        type="circle"
                        :percentage="
                          item.progress > 0 ? item.progress - 1 : item.progress
                        "
                        color="#000000"
                      ></el-progress> -->

                      <el-progress
                        type="circle"
                        :percentage="item.progress"
                        color="#000000"
                      ></el-progress>
                    </div>

                    <el-tooltip 
                      class="item"
                      v-if="!imgMobile"
                      v-show="item.move && !isNotShowBg"
                      effect="dark"
                      :content="imgTip"
                      placement="top"
                      :popper-class="
                        imgTip == '双击取消分隔' ? 'atooltip' : 'merge'
                      "
                    >
                      <!-- @click="openSwiper(index)" -->
                      <div
                        class="bg"
                        @dblclick="breakUp(index)"
                      >
                        <p>{{ item.srot }}</p>
                        <!-- <p v-if="item.shape == 0" class="shapeImg">横图</p>
                        <p v-if="item.shape == 1" class="shapeImg">竖图</p> -->

                      </div>
                    </el-tooltip>
                

                  </div>
                  <div v-if="(!imgMobile || (imgMobile && index != mobileIndex))" >
                    <div v-if="item.width1 && item.height1" class='item-name' :style="{ 'width': ((item.width1 * 120)/item.height1) + 'px' }">{{item.file.name}}</div>
                    <div v-else class='item-name' style="width: 120px;">{{item.file.name}}</div>
                    <!-- <div class='item-name' style="{{img.width}};">{{item.file.name}}</div> -->
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div v-if="userInfo.is_expire == 1 && userInfo.is_download == 1">
            <div class="fileList">
              <div class="listNull">
                <img
                  src="../../assets/img/download-all.svg"
                  alt
                  class="imgIcon"
                  ondragstart="return false;"
                />
                <div class="propaganda">
                  <p v-if="download_status== 0" class="oneTitle">轻点按钮</p>
                  <!-- <p v-if="download_status== 1" class="oneTitle">下载进行中</p> -->
                  <p v-if="download_status== 1" class="oneTitle">{{download_index}}/{{download_total}}</p>
                  <p v-if="download_status== 2" class="oneTitle">下载已完成</p>

                  <p v-if="download_status== 0" class="oneTitle1">一次性下载全部内容</p>
                  <p v-if="download_status== 1" class="oneTitle1">下载完成前请勿关闭或刷新</p>
                  <p v-if="download_status== 2" class="oneTitle1">欢迎你再次使用云作品</p>
                  <!-- <p>支持JPG\TIFF\BMP\PNG\GIF\WEBP\HELF格式，</p> -->
                  <p style="color: rgb(0, 0, 0, 0.6);">这项服务仅提供一次</p>
                  <p style="color: rgb(0, 0, 0, 0.6);">请在{{userInfo.download_endtime}}前完成下载</p>
                </div>

                <div v-if="download_status== 0" class="addBtn" @click="imgDownload($event)">
                  <span>开始下载</span>
                </div>

                <div v-if="download_status== 1" class="addBtn" style="background: rgba(0,0,0,0.2);">
                  <span>下载中</span>
                </div>

                <div v-if="download_status== 2" class="addBtn" style="background: rgba(0,0,0,0.2);">
                  <span>下载完成</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 一个view框 -->
      <div class="oneView" v-if="!viewStatus">
        <div class="viewTitle">
          <div class="placeholderStyle">
            <span class="currentDir">批量上传至云作品</span>
            <div style="display: inline-block" @click="switchBind">
              <img src="../../assets/img/arrowRight.svg" alt />
              <span>展开本地文件夹目录</span>
            </div>
          </div>
        </div>
        <div class="oneViewNull">
          <input type="file" class="tuozhuai" @change="dragImg($event)" />
          <div class="contantNull">
            <div class="fakeBtn">
              <img src="../../assets/img/folderIcon.svg" alt />
              导入本地文件夹
              <input
                type="file"
                class="inputFileStyle"
                webkitdirectory
                multiple
                @change="addProList($event)"
              />
            </div>
            <p>或将图片拖拽到这里上传</p>
            <p
              style="
                color: #666666;
                font-size: 13px;
                font-weight: 400;
                margin-top: 3px;
              "
            >
              支持：png、jpg、jpeg、bmp
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- food -->
    <div class="footer" v-if="upDownArr.length != 0 && !syncMask">
      <div class="leftProess">

        <div class="jindu">
        <p v-if="allDataSize < 1024">{{ allDataSize }}B</p>
        <p v-else-if="1024 <= allDataSize && allDataSize < 1048576">{{ (allDataSize / 1024).toFixed(2) }}KB</p>
        <p v-else-if="1048576 <= allDataSize && allDataSize < 1073741824">{{ (allDataSize / 1048576).toFixed(2) }}MB</p>
        <p v-else-if="1073741824 <= allDataSize && allDataSize < 1099511627776">{{ (allDataSize / 1073741824).toFixed(2) }}GB</p>
        </div>
        
        <div class="jindu">/</div>
        
        <div class="jindu">
          <p v-if="!upDownDataSize">计算中</p>
          <p v-if="upDownDataSize < 0">计算中</p>
          <p v-else-if="0 < upDownDataSize && upDownDataSize < 1024" >{{ upDownDataSize }}B</p>
          <p v-else-if="1024 <= upDownDataSize && upDownDataSize < 1048576" >{{ (upDownDataSize / 1024).toFixed(2) }}KB</p>
          <p v-else-if="1048576 <= upDownDataSize && upDownDataSize < 1073741824" >{{ (upDownDataSize / 1048576).toFixed(2) }}MB</p >
          <p v-else-if="1073741824 <= upDownDataSize && upDownDataSize < 1099511627776">{{ (upDownDataSize / 1073741824).toFixed(2) }}GB</p>
        </div>
        

        <div class="pNum">
          <p>已添加{{ upDownArr.length }}张图片</p>
          <p style="margin-left:10px">已分隔{{ axiosArr.length }}个作品</p>
        </div>

      </div>
      <div class="conterDiv">
        <template v-if="upDownArr.length != 0 && !loading && !syncMask">
          <template v-if="!upSubmit">
            <el-tooltip
              class="item"
              effect="dark"
              :content="moveTip"
              placement="top"
              popper-class="familyClass"
            >
              <!-- {{remaining}}  -->
              <div
                class="saveToXcx"
                style="background:rgba(0,0,0,0.1)"
                @mouseenter="moveBtn"
              >
                <p class="xcxP2">同步至小程序</p>
              </div>
            </el-tooltip>
          </template>

          <template v-if="upSubmit">
            <div class="saveToXcx" @click="getHost()">
              <p class="xcxP2">同步至小程序</p>
            </div>
          </template>
        </template>

        <div class="saveToXcxs" v-if="loading">
          <p class="xcxP2">
            <img src="../../assets/img/loads.svg" alt class="loads" />
            同步中
          </p>
        </div>

        <div class="saveToXcx" v-if="syncMask">
          <p class="xcxP1">同步成功</p>
        </div>

        <div class="agoAdd">
          <p>+ 继续添加图片</p>
          <input
            type="file"
            multiple
            ref="input1"
            @change="imgUpload($event)"
          />
        </div>
        <!-- <p class="pNum">
          <span>{{upDownArr.length}}作品</span>
          <span>{{axiosArr.length}}项目</span>
        </p>-->
      </div>
    </div>

    <!-- 视频弹窗 -->
    <div class="videoMask" v-if="videoStatus">
      <div class="videoView">
        <!--  -->
        <video autoplay controls loop muted width="100%" height="100%">
          <!-- <source
            src="https://file.zuopin.cloud/%E8%B6%85%E7%88%BD%E6%8C%87%E5%8D%97.mp4"
            type="video/mp4"
          /> -->
          <source
            src="https://file.zuopin.cloud/finishGuide_video2023_169.MP4"
            type="video/mp4"
          />
        </video>
      </div>
      <div class="videoUpMask">
        <p></p>
        <div class="closeView">
          <img src="../../assets/img/closeVideo.svg" alt @click="closeVideo" />
        </div>
      </div>
    </div>

    <!-- 点击查看大图弹窗  -->
    <div class="maskSwiper" @click.self="closeSwiper" v-show="previewImg">
      <div class="closeView" @click="closeSwiper">
        <img src="../../assets/img/closeSwiper.svg" alt class="nnnno" />
      </div>
      <div class="swiperContant" @click.self="closeSwiper">
        <div class="swiperBtn" @click="onBind">
          <img
            src="../../assets/img/swiperLast.svg"
            class="swiperIcon"
            alt
            ondragstart="return false;"
          />
        </div>
        <div class="swiperImg">
          <el-carousel
            :initial-index="current"
            indicator-position="none"
            :autoplay="false"
            @change="swiperChange"
            ref="remarkCarusel"
            arrow="never"
          >
            <el-carousel-item v-for="(item, index) in upDownArr" :key="index">
              <div class="swiperItem">
                <img
                  :src="item.qiniu2"
                  alt
                  class="qiniuImg"
                  ref="qiniuImg"
                  ondragstart="return false;"
                  @load="imgLoad(item)"
                />
                <div v-if="item.loading != 1" class="loading">
                  <img
                    src="../../assets/img/loads.svg"
                    alt
                    class="loads loadImg"
                  />
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>

          <div
            class="swiperList"
            ref="instructions"
            :style="{ 'margin-left': -(current * itemWidth) + 'px' }"
          >
            <div class="conterDiv" ref="leftDistance">
              <div
                class="thumbnail"
                v-for="(item, index) in upDownArr"
                :key="index"
                @click="swiperDj(index)"
                :class="current == index ? 'check' : ''"
              >
                <img
                  :src="item.qiniu"
                  alt
                  ondragstart="return false;"
                  @load="imgLoad(item)"
                />
                <div v-if="item.loading != 1" class="indicator">
                  <img
                    src="../../assets/img/loads.svg"
                    alt
                    class="loads littleLoad"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiperBtn" @click="nextBind">
          <img
            src="../../assets/img/swiperNext.svg"
            class="swiperIcon"
            alt
            ondragstart="return false;"
          />
        </div>
      </div>
    </div>

    <!-- 添加项目名称 -->
    <div class="maskSwiper" @click.self="closeMask" v-if="inputName">
      <div class="projectName">
        <div class="title">
          <div class="title_text">
            <div class="title_1">填写作品名称</div>
            <!-- <div class="title_2" >可以不填任何信息，去小程序编辑。</div> -->
            <!-- <div class="title_2" >将全部图片分隔为作品后，点击「同步至小程序」即可完成批量创建。</div> -->
            <div class="title_2" >将窗口中的图片全部分隔为作品后，点击右下角「同步至小程序」即可完成批量创建。</div>
          </div>
          <img src="../../assets/img/stepsClose.svg"  style="width: 14px; height: 14px; cursor: pointer;" alt @click="closeMask" />
        </div>
        <div class="proItem">
          <div class="projectFormItem">
            <div class="formItem">
              <div class="inputBg">
                <input
                  type="text"
                  name
                  ref="projectAutofocus"
                  placeholder="16个汉字或32个字符"
                  @input="projectNameFunc($event)"
                  v-model="projectName"
                  autofocus
                />
              </div>
            </div>
          </div>
        </div>

        <el-tooltip
          class="item"
          effect="dark"
          content="可以不填任何信息，去小程序编辑"
          placement="top"
        >
          <div class="submitBtn" @click="submitBtn">确认</div>
        </el-tooltip>
      </div>
    </div>

    <!-- 上传错误文件弹窗 -->
    <div class="maskOut" v-if="errorMask">
      <!-- 退出弹框 -->
      <div class="outMask">

        <!-- <div class="outClose">
          <img
            src="../../assets/img/stepsClose.svg"
            alt
            @click="closeErrorMask"
            style="width: 14px; height: 14px; cursor: pointer;"
          />
        </div> -->

        <div>
          <p class="titleP">有 {{ noImg }} 张图片无法添加</p>
          <p class="titleG">仅支持JPG\BMP\PNG\GIF\WEBP\HELF格式</p>
        </div>
        <div class="btnMoni">
          <div class="noOut" @click="closeErrorMask">知道了</div>
        </div>
      </div>
    </div>

    <top-tip :visible="tipShow" :positive="tipType" :message="tipMessage" />

    <!-- 同步成功弹窗 -->
    <div class="syncMask bg9" v-show="syncMask">
      <div class="syncSuccess">
        <div>
          <img :src="xcxQrcode" alt class="qrcode" />
          <!-- <p class="tip">成功同步{{ axiosArr.length }}个作品</p> -->
          <p class="tip">{{ upDownArr.length }}张图片已成功同步至小程序</p>
        </div>  
        <div style="width: 100%;">
          <div class="continue" @click="emptyData">继续整理
            <input
              type="file"
              multiple
              ref="input1"
              @change="imgUpload($event)"
            />
          </div>
          <div class="returnBtn" style="margin-top:10px" @click="returnBtn">退出</div>
        </div>
      </div>
    </div>

    <!-- 确认弹窗 -->
    <div class="syncMask" v-if="submitMask">
      <div class="outMask">
        <!-- <div class="outClose">
          <img src="../../assets/img/stepsClose.svg" style="width: 14px; height: 14px; cursor: pointer;" alt @click="againCreat" />
        </div> -->
        <div>
          <p class="titleP">部分作品中的图片超过20张</p>
          <p class="titleG">由于微信的限制，图片过多将导致排序困难、图片无法预览及闪退。建议拆分成多个作品，再合并为作品集使用。</p>
        </div>
        <div class="btnMoni">
          <div class="noOut" @click="againCreat">返回修改</div>
          <div class="okOut" style="margin-top: 10px;" @click="continueSubmit">仍要同步（不建议）</div>
        </div>
      </div>
    </div>
    <!-- 透明的遮罩  -->
    <div class="transparentMask" v-show="transparentMask"></div>
  </div>
</template>

<script>
import TopTip from "@/components/TopTip.vue";
import contentTitle from "@/utils/contentTitle";
import headers from "../../components/transferHeader";
import lrz from "lrz";
let axios = require("axios");
import draggable from "vuedraggable";
import Vue from "vue";
import {
  qiniuGetParams,
  addPhotographerWorkSource,
  addPhotographerWork,
  wordcheck,
  xcxQrcode,
  sendPhotographerWorkInfo,
  userInfo,
  downloadAllImg,
} from "@/request/api";

import { childElement } from "@/request/childElement";
import { Message } from "element-ui";
import $ from "jquery";

var time = null;

export default {
  name: "transferView",
  components: { headers, draggable, TopTip },
  data() {
    return {
      current: 0,
      tipStatus: false,
      submitMask: false,
      syncMask: false,
      videoStatus: false,
      viewStatus: true,
      inputName: false,
      projectName: "",
      infoBtnText: "分隔",
      isshift: false,
      dropShow: true,
      clickIndex: null,
      swiperHeight: "0px",
      checkNav: 0,
      transparentMask: false,
      localList: [{ name: "name" }],
      upImgList: [{ name: "name" }],
      preTrue: false,
      previewImg: false,
      dataInte: [], //处理文件夹层级arr
      allDataUn: [[], []], //所有本地数据 第一个数组放文件夹，第二个数组放图片
      upDownArr: [], //上传的数组
      axiosArr: [], //项目创建的数组
      backupData: [], //正确的数据备份，当用户操作违反规则的时候，用这份数据替换 违反规则的数据
      showLocalArr: [], //显示本地的文件夹
      backUp: [], //备份的本地文件夹
      navArr: [], // 导航目录
      addFileStatus: true, //添加文件夹的按钮
      imgListArr: [], //选中文件夹的图片列表
      upSubmit: false,
      loading: false,
      remaining: 0,
      maskHeight: 500,
      // imgTip: "双击分隔作品",
      imgTip: "",
      forNum: 0,
      moveTip: "",
      errorMask: false,
      tipShow: false,
      tipType: false,
      tipMessage: "未知错误",
      xcxQrcode: "",
      btnRed: false,
      imgMobile: false,
      mobileIndex:-1,
      allDataSize: 0,
      upDownDataSize: 0,
      itemWidth: 80,

      currentUrl: "",
      isNotShowBg:false,

      delay_enter:null,
      //delay_del_enter:null,
      delay_move:null,

      userInfo: {},

      download_status:0,
      download_total:0,
      download_index:0,
    };
  },
  mounted() {
    //拖拽的目标节点
    var dropZone = this.$refs.drop;
    if (dropZone) {
      function hideDropZone() {
        dropZone.style.display = "none";
      }

      function allowDrag(e) {
        if (true) {
          e.preventDefault();
        }
      }

      function handleDrop(e) {
        e.preventDefault();
        hideDropZone();
      }

      // 监听widow上的事件
      window.addEventListener("dragenter", function (e) {
        dropZone.style.display = "block";
      });

      dropZone.addEventListener("dragenter", allowDrag);
      dropZone.addEventListener("dragover", allowDrag);

      dropZone.addEventListener("dragleave", function (e) {
        hideDropZone();
        console.log(e, "松开1");
      });
    }

    //监听鼠标滚动事件

    window.addEventListener(
      "mousewheel",
      this.debounce(this.handleScroll, 100),
      true
    ) ||
      window.addEventListener(
        "DOMMouseScroll",
        this.debounce(this.handleScroll, 100),
        false
      );
    
    // 记录当前页面url
	  this.currentUrl = window.location.href
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))

    this.getUserInfo();
  },
  updated() {
    var dropZone = this.$refs.drop;
    if (dropZone) {
      function hideDropZone() {
        dropZone.style.display = "none";
      }

      function allowDrag(e) {
        if (true) {
          e.preventDefault();
        }
      }

      function handleDrop(e) {
        e.preventDefault();
        hideDropZone();
      }

      // 监听widow上的事件
      window.addEventListener("dragenter", function (e) {
        dropZone.style.display = "block";
      });

      dropZone.addEventListener("dragenter", allowDrag);
      dropZone.addEventListener("dragover", allowDrag);

      dropZone.addEventListener("dragleave", function (e) {
        hideDropZone();
        console.log(e, "松开2");
      });

      // this.elementHeightFunctiongetUserInfo();
    }
  },
  watch: {
    syncMask(visible) { if (visible) this.myXcxQrcode(); }
  },
  created() {
    //
    this.keyevent();
    this.videoStatusBind();
  },
  methods: {
    getUserInfo() {
      var that = this;
      userInfo().then(res => {
        console.log(res, "个人信息？");
        that.userInfo = res.data.data;
      });
    },
    // 视频弹出的状态
    videoStatusBind() {
      let status = window.localStorage.getItem("videoStatus");
      if (status) {
        this.videoStatus = false;
      } else {
        this.videoStatus = true;
        window.localStorage.setItem("videoStatus", true);
      }
    },

    //函数防抖
    debounce(func, wait) {
      let timeout;
      return function () {
        let context = this;
        let args = arguments;
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, wait);
      };
    },

    // 鼠标滚动
    handleScroll(e) {
      console.log(this.previewImg, "this.previewImg");
      if (this.previewImg) {
        let direction = e.deltaY > 0 ? "down" : "up";
        let current = this.current;

        direction == "down" ? current++ : current--;

        if (this.$refs.remarkCarusel.setActiveItem) {
          this.$refs.remarkCarusel.setActiveItem(current);
        }
      }
      this.scrollAddress();
    },

    swiperDj(index) {
      this.$refs.remarkCarusel.setActiveItem(index);
    },
    swiperChange(val) {
      this.current = val;
      console.log(val, "?11111111111111");
    },

    // 上一个
    onBind() {
      var current = this.current;
      this.$refs.remarkCarusel.setActiveItem(current - 1);
      this.scrollAddress();
    },
    // 下一个
    nextBind() {
      var current = this.current;
      this.$refs.remarkCarusel.setActiveItem(current + 1);
      this.scrollAddress();
    },

    // 设置位置
    scrollAddress() {
      let _this = this;
      let itemWidth = window.screen.availWidth / 16;
      this.itemWidth = window.screen.availWidth / 16.8;
    },

    closeSwiper() {
      this.previewImg = false;
      this.dropShow = true;
    },

    // 字符验证
    stringValidation(val) {
      let len = 0;
      let that = this

      console.log(val, "获取val");
      val = contentTitle.work(val);
      console.log(val, "修改后的val");

      for (let i = 0; i < val.length; i++) {
        var a = val.charAt(i);
        if (a.match(/[^\x00-\xff]/gi) != null) {
          len += 2;
        } else {
          len += 1;
        }
      }

      return len;
    },

    // 项目名
    projectNameFunc(event) {
      this.projectName = event.target.value;
    },

    // 我的小程序码
    myXcxQrcode() {
      if (this.xcxQrcode || this._qrPending) return;
      this._qrPending = true;
      // 我的作品二维码
      const params = {
        path: "pages/homePage/homePage",
        width: 202,
      };
      xcxQrcode(params).then((res) => {
        if (this._isDestroyed || !res || res.status !== 200) return;
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        this.xcxQrcode = url;
      }).catch(() => {}).finally(() => { this._qrPending = false; });

    },
    // 返回上一页
    returnBtn() {
      this.emptyData()
      this.syncMask = false;
      this.$router.push({
        path: "/tab",
      });
    },
    //清空数据
    emptyData() {
      this.upDownArr = [];
      this.axiosArr = [];
      this.syncMask = false;
      this.allDataSize = 0;
      this.upDownDataSize = 0;
    },

    closeErrorMask() {
      this.errorMask = false;
    },

    elementHeightFunction() {
      let _this = this;
      let element = document.getElementById("content").getBoundingClientRect()
        .top;
      let height = window.innerHeight - element;
      window.onresize = (e) => {
        height = window.innerHeight - element;
      };

      this.maskHeight = height;
    },
    //over
    dragover(event) {
      event.preventDefault();
    },

    drop(event) {
      this.$refs.drop.style.display = "none";
    },

    dragenter(event) {},

    dragleave(event) {},

    keyevent() {
      var that = this;
      document.onkeydown = function (e) {
        //按下键盘
        switch (e.keyCode) {
          case 16:
            that.isshift = true;
            break;
        }
      };
      document.onkeyup = function (e) {
        console.log(e.keyCode);
        //放弃键盘
        switch (e.keyCode) {
          case 16:
            that.isshift = false;
            break;
          case 37: //按下左方向
            that.onBind();
            break;
          case 39: //按下右方向
            that.nextBind();
            break;
        }
      };
    },

    openVideo() {
      this.videoStatus = true;
    },
    clickNav(index) {
      this.checkNav = index;
    },
    closeVideo() {
      var that = this;
      that.videoStatus = false;
      that.tipStatus = true;
      setTimeout(function () {
        that.tipStatus = false;
      }, 1000);
    },
    switchBind() {
      this.viewStatus = !this.viewStatus;
    },

    moveBtn() {
      let arr = this.upDownArr;
      let axios = this.axiosArr;
      if (axios.length == 0) {
        this.moveTip = "请先双击图片，分隔作品";
      } else {
        let axLength = 0;
        axios.forEach((item) => {
          axLength = axLength + item.arr.length;
        });

        let ax = arr.length - axLength;
        if (ax != 0) {
          this.moveTip = "还有" + ax + "张图片未分隔";
        }
      }
    },

    previewTab() {
      if (!this.preTrue) {
        let arr = this.showLocalArr.filter((item) => {
          if (item.check == 1) {
            return item;
          }
        });
        if (arr.length != 0) {
          this.preTrue = !this.preTrue;
          this.recursive(arr);
        } else {
          console.log("请选择要预览的文件夹");
        }
      } else {
        this.preTrue = !this.preTrue;
        this.showLocalArr.forEach((item) => {
          item.check = 0;
        });
        this.imgListArr = [];
      }
    },

    // 递归
    recursive(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].dir == 0) {
          this.imgListArr.push(data[i]);
        } else {
          this.recursive(data[i].children);
        }
      }
      console.log(data, "data");
      console.log(this.imgListArr, "this.imgListArr");
    },

    // 选中本地文件夹
    addProList(event) {
      console.log(event);
      let arr = event.srcElement.files;
      let arrData = [];
      // 1,先把图片解析出来
      arr.forEach((item) => {
        const url = window.URL.createObjectURL(item, { quality: 1 });
        lrz(url).then((resLrz) => {
          const imgUrl = window.URL.createObjectURL(resLrz.file);
          arrData.push({
            file: item,
            path: item.webkitRelativePath,
            imgUrl: imgUrl,
          });
          console.log(arrData, "arr");
          if (arrData.length == arr.length) {
            /**
             * 等图片全部解析出来后
             * 把字符串路径转换为树状图数据
             * */

            this.showLocalArr = this.showLocalArr.concat(
              this.pathToTree(arrData)
            );
            this.backUp = this.backUp.concat(this.pathToTree(arrData));
            console.log(this.showLocalArr, "this.showLocalArr");
          }
        });
      });
    },

    // 选中，Shift+左键
    checkImg(idx) {
      var that = this;
      var arr = this.showLocalArr;

      // 判断文件类型，图片直接去上传
      var dir = arr[idx].dir;
      if (dir == 0) {
        // if (arr[idx].check == 0) {
        arr[idx].check = 1;
        this.upDownArr.push(arr[idx]);
        let i = that.upDownArr.length - 1;
        this.uploadBind(that.upDownArr[i], i);
        // } else {
        //   Message.error({
        //     message: "该图片已选中，请勿重复上传",
        //     duration: 1000,
        //     offset: 300
        //   });
        // }
      } else {
        // 判断是否有Shift键按下
        if (this.isshift) {
          let arr1 = arr.filter((item) => {
            if (item.check == 1) {
              return item;
            }
          });

          if (arr1.length == 0) {
            for (let i = 0; i < arr.length; i++) {
              if (i <= idx) {
                arr[i].check = 1;
              }
            }
          } else {
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].check == 1) {
                if (idx > i) {
                  arr.forEach((item, index) => {
                    if (index >= i && index <= idx) {
                      item.check = 1;
                    } else {
                      item.check = 0;
                    }
                  });
                } else {
                  arr.forEach((item, index) => {
                    if (index >= idx && index <= i) {
                      item.check = 1;
                    } else {
                      item.check = 0;
                    }
                  });
                }
                break;
              } else {
              }
            }
          }
        } else {
          arr.forEach((item, index) => {
            if (idx == index) {
              item.check = 1;
            } else {
              item.check = 0;
            }
          });
        }
      }

      // 选中的
    },

    // 双击进入
    dblCheckImg(item, index) {
      var that = this;
      console.log(item, index);
      if (item.dir == 1) {
        this.navArr.push(item.title);
        this.addFileStatus = false;
        this.showLocalArr = item.children;
      }
    },

    // 点击首页
    checkHome() {
      this.showLocalArr = this.backUp;
      this.navArr = [];
      this.addFileStatus = true;
    },

    //点击导航，返回上层
    returnUp(index) {
      var that = this;

      this.navArr.splice(index + 1);
      let arr = this.backUp;
      console.log(this.navArr, "this.navArr");

      for (let i = 0; i < this.navArr.length; i++) {
        for (let j = 0; j < arr.length; j++) {
          if (this.navArr[i] == arr[j].title) {
            arr = arr[j].children;

            if (i == this.navArr.length - 1) {
              this.showLocalArr = arr;
            }

            break;
          }
        }
      }
    },

    // 点击空白的地方，取消选中
    cancelCheck() {
      this.showLocalArr.forEach((item) => {
        item.check = 0;
      });
    },

    datadragStart(evt) {

      setTimeout(() => {
        this.dropShow = false;
        this.imgMobile = true;
        this.mobileIndex =  evt.oldIndex

        console.log('datadragStart', this.imgMobile)
        console.log('datadragStart', this.mobileIndex)
      
        this.upDownArr.forEach((item) => {
          item.move = false;
          item.srot = 0;
          item.deleteC = false;
        });
        evt.preventDefault();
        console.log("拖动前的索引 :" + evt.oldIndex);

      }, 100);
    },
    setMove(flag){
      console.log('setMove');

      clearTimeout(time); //清除
      clearTimeout(this.delay_move); //首先清除计时器

      this.delay_move =  setTimeout(() => {
        this.imgMobile = flag;
      }, 400);
    },
    datadragMove(evt) {
      console.log("move:", evt);
    },
    datadragEnd(evt) {
      console.log("datadragEnd", evt);

      evt.preventDefault();
      console.log("拖动前的索引 :" + evt.oldIndex);
      console.log("拖动后的索引 :" + evt.newIndex);

      this.dealWith();
      this.func1();
      
      //3、停止拖拽时，图片经常变白，需要把鼠标放在其他图片上或拖拽一下才会恢复
      this.dropShow = true;
      setTimeout(() => {
        this.imgMobile = false;
        this.mobileIndex = -1;
      }, 100);

      let that = this
      //双击合并时，不立即出现蒙层，做个延迟
      that.isNotShowBg = true;

      setTimeout(() => {
        that.isNotShowBg = false;
      }, 1500);
    },

    //图片加载完成
    imgLoad(item) {
      var that = this;
      item.loading = 1;
    },

    // 选中
    checkClick(index) {
      var that = this;

      // if (this.imgListArr[index].check == 0) {
      this.imgListArr[index].check = 1;
      that.upDownArr.push(this.imgListArr[index]);
      let i = that.upDownArr.length - 1;
      that.uploadBind(that.upDownArr[i], i);
    },

    // 拖拽上传图片
    imgUpload(event) {
      console.log('imgUpload',event);
      let files = event.srcElement.files;

      let _this = this;
      let file = [];
      let noImgArr = [];
      for (let i = 0; i < files.length; i++) {
        console.log(files, "wantedNodefiles");
        if (
          //图片
          files[i].type.indexOf("image/jpeg") != -1 ||
          files[i].type.indexOf("image/jpg") != -1 ||
          files[i].type.indexOf("image/png") != -1 ||
          files[i].type.indexOf("image/gif") != -1 ||
          files[i].type.indexOf("image/webp") != -1 ||
          //files[i].type.indexOf("image/tiff") != -1 ||
          //files[i].type.indexOf("image/tif") != -1 ||
          files[i].type.indexOf("image/bmp") != -1 ||
          files[i].type.indexOf("image/helf") != -1 ||
          files[i].type.indexOf("image/HELF") != -1 ||
          files[i].type.indexOf("image/JPEG") != -1 ||
          files[i].type.indexOf("image/JPG") != -1 ||
          files[i].type.indexOf("image/PNG") != -1 ||
          files[i].type.indexOf("image/GIF") != -1 ||
          files[i].type.indexOf("image/WEBP") != -1 ||
          //files[i].type.indexOf("image/") != -1 ||
          //files[i].type.indexOf("image/TIF") != -1 ||
          files[i].type.indexOf("image/BMP") != -1
          //files[i].type.indexOf("video/mp4") != -1
         ) {
          console.log(files[i].name);

          file.push(files[i]);
        } else {
          noImgArr.push(files[i]);
          this.errorMask = true;
        }
      }

      //按名称升序 Edit by hr 2022-03-22
      //console.log("file-sort-1",file);
      file.sort((a, b) => this.mixSort(a, b))
      //console.log("file-sort-2",file);

      this.noImg = noImgArr.length;

      let fileLength = file.length;

      let beforeLength = this.upDownArr.length;

      let num = 0;

      //一次拽入或一次选择上传，视为一批次，批次内的图片按文件名排序 ，这样就需要做成同步
      // for (let i = 0; i < file.length; i++) {
      //   let type = file[i].type.substring(0, 5);
      //   if (type == "image") {
      //     const url = window.URL.createObjectURL(file[i]);
      //     console.log('file',file[i]);
      //     // 0,横屏，1,竖屏
      //     let shape = 0;
      //     let img = new Image();
      //     img.src = url;
      //     img.onload = function (a) {
      //       console.log('sss',a)

      //       console.log('file-1',file[i]);
      //       console.log('file-2',img);
      //       if (img.width >= img.height) {
      //         shape = 0;
      //       } else {
      //         shape = 1;
      //       }
      //       _this.allDataSize = _this.allDataSize + file[i].size;
      //       _this.upDownArr.push({
      //         file: file[i],
      //         move: false,
      //         srot: 0,
      //         deleteC: false,
      //         shape: shape,
      //         projectName: "",
      //         type: "image",
      //         name:file[i].name,
      //       });

      //       num = num + file[i].size;

      //       let z = _this.upDownArr.length - 1;
      //       _this.uploadBind(_this.upDownArr[z], z);

      //       /*
      //       //按名称升序 Edit by hr 2022-03-22
      //       _this.upDownArr.sort((a, b) => _this.mixSort(a, b))
      //       console.log("upDownArr-sort", _this.upDownArr);
      //        _this.$forceUpdate();
      //       */
      //     };

      //     //console.log("upDownArr-sort-2", _this.upDownArr);
      //     img.onerror = function () {
      //       console.log("渲染错误");
      //     };
      //   } else if (type == "video") {
      //     const url = window.URL.createObjectURL(file[i]);
      //     _this.allDataSize = _this.allDataSize + file[i].size;
      //     _this.upDownArr.push({
      //       file: file[i],
      //       move: false,
      //       srot: 0,
      //       deleteC: false,
      //       shape: 3,
      //       projectName: "",
      //       type: "video",
      //       name:file[i].name,
      //     });

      //     num = num + file[i].size;

      //     let z = _this.upDownArr.length - 1;
      //     _this.uploadBind(_this.upDownArr[z], z);

      //     /*
      //     //按名称升序 Edit by hr 2022-03-22
      //     _this.upDownArr.sort((a, b) => _this.mixSort(a, b))
      //     console.log("upDownArr-sort", _this.upDownArr);
      //     _this.$forceUpdate();
      //     */
      //   }
      // }
      
      //不可同步小程序
      _this.upSubmit = false;

      //一次拽入或一次选择上传，视为一批次，批次内的图片按文件名排序 ，这样就需要做成同步
      _this.fileProcess(file, 0, num)
    },
    fileProcess(file, i, num){
      let _this = this;

      if(i >= file.length){
        //this.return;
        return;
      }

      let type = file[i].type.substring(0, 5);
      if (type == "image") {
        const url = window.URL.createObjectURL(file[i]);
        console.log('file',file[i]);
        // 0,横屏，1,竖屏
        let shape = 0;
        let img = new Image();
        img.src = url;
        img.onload = function (a) {
          // console.log('sss',a)
          // console.log('file-1',file[i]);
          // console.log('file-2',img);

          if (img.width >= img.height) {
            shape = 0;
          } else {
            shape = 1;
          }
          _this.allDataSize = _this.allDataSize + file[i].size;
          _this.upDownArr.push({
            file: file[i],
            move: false,
            srot: 0,
            deleteC: false,
            shape: shape,
            projectName: "",
            type: "image",
            name:file[i].name,
          });

          num = num + file[i].size;

          let z = _this.upDownArr.length - 1;
          _this.uploadBind(_this.upDownArr[z], z, true, file, i, num);

          /*
          //按名称升序 Edit by hr 2022-03-22
          _this.upDownArr.sort((a, b) => _this.mixSort(a, b))
          console.log("upDownArr-sort", _this.upDownArr);
            _this.$forceUpdate();
          */

          //Edit by hr 2023-03-30 改成一次一张
          //_this.fileProcess(file, i + 1, num)
        };

        //console.log("upDownArr-sort-2", _this.upDownArr);
        img.onerror = function () {
          console.log("渲染错误");
        };
      } else if (type == "video") {
        const url = window.URL.createObjectURL(file[i]);
        _this.allDataSize = _this.allDataSize + file[i].size;
        _this.upDownArr.push({
          file: file[i],
          move: false,
          srot: 0,
          deleteC: false,
          shape: 3,
          projectName: "",
          type: "video",
          name:file[i].name,
        });

        num = num + file[i].size;

        let z = _this.upDownArr.length - 1;
        _this.uploadBind(_this.upDownArr[z], z, true, file, i, num);

         //Edit by hr 2023-03-30 改成一次一张
        //_this.fileProcess(file, i + 1, num)
        /*
        //按名称升序 Edit by hr 2022-03-22
        _this.upDownArr.sort((a, b) => _this.mixSort(a, b))
        console.log("upDownArr-sort", _this.upDownArr);
        _this.$forceUpdate();
        */
      }
    },
    getRegValue(item){
      const regexPunc = /[\s!！#$%&(（)）,，、.。;；？@[\]^_`{}~‘’“”《》￥【】+=·…]/
      const regexNum = /[0-9]/
      const regexEng = /[A-Za-z]/
      const regexCh = /[\u4E00-\u9FFF]/

      if (item.match(regexEng)) {
        return 0
      }
      if (item.match(regexCh)) {
        return 1
      }
      if (item.match(regexPunc)) {
        return 2
      }
      if (item.match(regexNum)) {
        return 3
      }
      return -1
    },
    mixSort(_a, _b) {
      let that = this

      let name1 = _a.name;
      let name2 = _b.name;

      // 排序大小： 特殊字符 > 数字 > 字母 > 汉字
      // 如果第一个字符相等，再比较下一个字符
      let compareValue = false
      const minLength = Math.min(name1.length, name2.length)
      let i = 0
      do {
        const aIndex = name1.charAt(i)
        const bIndex = name2.charAt(i)
        
        const nameFirstType = [aIndex, bIndex].map((item) => {
          return that.getRegValue(item)
        })

        // 如果第一个字符不相等
        if (aIndex !== bIndex) {

          var aNext = 0;
          var bNext = 0;

          //判断下一位
          if(i < name1.length - 1){
            const aIndex1 = name1.charAt(i + 1)
            aNext = that.getRegValue(aIndex1)
          }

          //判断下一位
          if(i < name2.length - 1){
            const bIndex1 = name2.charAt(i + 1)
            bNext = that.getRegValue(bIndex1)
          }

          //下一位是数字，排在后面
          if(aNext != bNext){
            if(aNext == 3){
              return false;
            }
            if(bNext == 3){
              return true;
            }

            //下一位是空格，排在前面
            if(aNext == -1){
              return false;
            }
            if(bNext == -1){
              return true;
            }
          }

          if (nameFirstType[0] !== nameFirstType[1]) {
            compareValue = nameFirstType[0] - nameFirstType[1]
            break
          } else {
            // 中文需根据拼音顺序
            compareValue = aIndex.localeCompare(bIndex, 'zh')
            break
          }
        }
        if (i === minLength) {
          compareValue = name1.localeCompare(name2, 'zh')
          break
        }
        i += 1
      } while (i <= minLength)
      return compareValue
      },
    mixSort_del2(_a, _b) {

      let name1 = _a.name;
      let name2 = _b.name;

      const regexPunc = /[\s!！#$%&(（)）,，、.。;；？@[\]^_`{}~‘’“”《》￥【】+=·…]/
      const regexNum = /[0-9]/
      const regexEng = /[A-Za-z]/
      const regexCh = /[\u4E00-\u9FFF]/
      // 排序大小： 特殊字符 > 数字 > 字母 > 汉字
      // 如果第一个字符相等，再比较下一个字符
      let compareValue = false
      const minLength = Math.min(name1.length, name2.length)
      let i = 0
      do {
        const aIndex = name1.charAt(i)
        const bIndex = name2.charAt(i)
        const nameFirstType = [aIndex, bIndex].map((item) => {
          if (item.match(regexEng)) {
            return 0
          }
          if (item.match(regexCh)) {
            return 1
          }
          if (item.match(regexPunc)) {
            return 2
          }
          if (item.match(regexNum)) {
            return 3
          }
          return -1
        })
        // 如果第一个字符不相等
        if (aIndex !== bIndex) {
          if (nameFirstType[0] !== nameFirstType[1]) {
            compareValue = nameFirstType[0] - nameFirstType[1]
            break
          } else {
            // 中文需根据拼音顺序
            compareValue = aIndex.localeCompare(bIndex, 'zh')
            break
          }
        }
        if (i === minLength) {
          compareValue = name1.localeCompare(name2, 'zh')
          break
        }
        i += 1
      } while (i <= minLength)
      return compareValue
    },
    //Edit by hr 2022-03-22 排序
    mixSort_del(_a, _b) {
      /*
      const a = _a
      const b = _b

      let cReg = /^[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]/
      if (!cReg.test(a.name) || !cReg.test(b.name)) {
        return a.name.localeCompare(b.name, 'en')
      } else {
        return a.name.localeCompare(b.name, "zh")
      }*/
      const reg = /[a-zA-Z0-9]/
      // 比对仅针对字符串，数字参与对比会导致对比的字符串转为number类型，变成NaN
      const a = _a.name.toString()
      const b = _b.name.toString()

      //长度比较，小的长度在前
      if(a.length != b.length)
      {
        return a.length - b.length
      }

      if(/^[a-zA-Z0-9]/i.test(a) || /^[a-zA-Z0-9]/i.test(b)){
        return a.localeCompare(b, 'en')
      }else {
        return a.localeCompare(b, 'zh-cn')
      }
      /*
      // 比对0号位的原因是字符串中有可能出现中英文混合的情况，这种仅按首位排序即可
      if (reg.test(a[0]) || reg.test(b[0])) {
        if (a > b) {
          return 1
        } else if (a < b) {
          return -1
        } else {
          return 0
        }
      } else {
        return a.localeCompare(b)
      }*/
    },
    // 点击重传
    againUp() {
      let _this = this;
      _this.upDownArr.forEach((item) => {
        if (item.upLoadStatus == 0) {
          _this.uploadBind(item);
        }
      });
    },

    // 多文件函数
    imgUpLoads(event) {
      let arr = event.srcElement.files;
      arr.forEach((item) => {
        const url = window.URL.createObjectURL(item, { quality: 1 });
        lrz(url).then((resLrz) => {
          console.log(resLrz, "reLrz");
          const imgUrl = window.URL.createObjectURL(resLrz.file);
          this.upDownArr.push({
            file: file,
            imgUrl: imgUrl,
          });
          let i = this.upDownArr.length - 1;
          this.uploadBind(this.upDownArr[i], i);
          if (arr.length == 1) {
            event.target.value = "";
          }
        });
      });
    },

    // 上传
    uploadBind(event, index, isNext, file, i, num) {
      let that = this;
      // let event = this.upDownArr[index];
      // if (index < length) {
      qiniuGetParams().then((res) => {
        console.log('uploadBind',event.file)
        var fromData = new FormData();
        fromData.append("file", event.file);
        fromData.append("token", res.data.data.upToken);
        
        var name = event.file.name
        var index = name.lastIndexOf(".")
        //获取后缀
        var ext = name.substring(index + 1) // wxs不支持substr
        var fileName = that.userInfo.photographer_id + '/' + that.getNowDateString()  + '_' + that.getCode()  +'.' + ext;
        console.log('uploadBind-fileName',fileName)
        fromData.append("key", fileName);
        
        that
          .axios({
            method: "post",
            url: "https://up-z2.qiniup.com",
            data: fromData,
            contentType: false,
            onUploadProgress: (progressEvent) => {
              this.upSubmit = false;
              Vue.set(event, "upLoadStatus", -1);
              Vue.set(
                event,
                "progress",
                Math.floor((progressEvent.loaded * 100) / progressEvent.total)
              );

              Vue.set(event, "loaded", progressEvent.loaded);
              if (that.upDownDataSize > that.allDataSize) {
                that.upDownDataSize = that.allDataSize;
              } else {
                let num = 0;
                that.upDownArr.forEach((item) => {
                  num = num + item.loaded;
                });
                that.upDownDataSize = num;
              }
            },
          })
          .then((res) => {
            console.log(res, "上传成功", event);
            
            that.func1();
            Vue.set(event, "key", res.data.key);
            Vue.set(event, "hash", res.data.hash);

            let exif = JSON.stringify(res.data.exif);
            let avinfo = JSON.stringify(res.data.avinfo);

            Vue.set(event, "width", res.data.width);
            Vue.set(event, "height", res.data.height);
            Vue.set(event, "fsize", res.data.fsize);
            Vue.set(event, "avinfo", avinfo);
            Vue.set(event, "exif", exif);
            Vue.set(event, "imageAve", res.data.imageAve);
            // if (event.type == "img") {
            if (event.type == "image") {
              //大于20M时，显示原图 19 * 1024 * 1024
              if(event.file.size >= 20 * 1000 * 1000){
                Vue.set(
                  event,
                  "qiniu",
                  "https://file.zuopin.cloud/" +
                    res.data.key
                );

                Vue.set(
                  event,
                  "qiniu2",
                  "https://file.zuopin.cloud/"
                );
              }
              else
              {
                Vue.set(
                  event,
                  "qiniu",
                  "https://file.zuopin.cloud/" +
                    res.data.key +
                    "?imageMogr2/thumbnail/300x300"
                );

                Vue.set(
                  event,
                  "qiniu2",
                  "https://file.zuopin.cloud/" +
                    res.data.key +
                    "?imageMogr2/thumbnail/900x900"
                );
              }

              // 图片地址
              var imgURL = event.qiniu;
              // 创建实例对象
              var img = new Image()
              // 图片地址
              img.src = imgURL

              img.onload = function () {
                Vue.set(event, "width1", img.width);
                Vue.set(event, "height1", img.height);

                console.log('event',event)
                that.$forceUpdate()
              }
            } else {
              Vue.set(
                event,
                "qiniu",
                "https://file.zuopin.cloud/" +
                  res.data.key +
                  "?vframe/jpg/offset/1/w/345"
              );

              Vue.set(
                event,
                "qiniu2",
                "https://file.zuopin.cloud/" +
                  res.data.key +
                  "?vframe/jpg/offset/1/w/345"
              );
            }

            if (
              (index && index == that.upDownArr.length - 1) ||
              that.upDownDataSize > that.allDataSize
            ) {
              that.upDownDataSize = that.allDataSize;
            }
            
            if(isNext){
              that.fileProcess(file, i + 1, num)
            }

          })
          .catch((err) => {
            console.log(err, "上传失败");
            Vue.set(event, "upLoadStatus", 0);

            if(isNext){
              that.fileProcess(file, i + 1, num)
            }

          });
      });
      // }
    },

    qiniuImgLoad(event) {
      let _this = this
      event.upLoadStatus = 1;
      event.width = 1;
      _this.$forceUpdate();
    },

    // 图片加载失败
    imgError(event) {
      const reduceUrl = window.URL.createObjectURL(event.file, { quality: 1 });
      lrz(reduceUrl).then((resLrz) => {
        const imgUrl = window.URL.createObjectURL(resLrz.file);
        event.qiniu = imgUrl;
        event.qiniu2 = imgUrl;
        event.upLoadStatus = 1;
      });
    },

    // .......
    func1() {
      let allNum = this.upDownArr.length;
      let axiosProAll = 0;
      for (let i = 0; i < this.axiosArr.length; i++) {
        axiosProAll = axiosProAll + this.axiosArr[i].arr.length;
      }

      let arr = this.axiosArr.filter((item) => {
        let arr2 = item.arr.filter((ite2) => {
          if (ite2.upLoadStatus != 1) {
            return ite2;
          }
        });

        if (arr2.length != 0) {
          return arr2;
        }
      });

      this.remaining = allNum - axiosProAll;

      if (allNum != axiosProAll) {
        this.upSubmit = false;
      } else {
        if (arr.length != 0) {
          this.upSubmit = false;
        } else {
          this.upSubmit = true;
        }
      }
    },

    //  删除上传图片
    deleteImg(i) {
      var that = this;

      that.upDownArr.splice(i, 1);
      let t = 0;
      that.upDownArr.forEach((item) => {
        t = t + item.file.size;
      });

      that.allDataSize = t;
      that.upDownDataSize = t;

      this.dealWith();
      this.func1();
      this.enter(i);
    },

    deleteEnter(index) {
      //arr[index].deleteC = true;
      let arr = this.upDownArr;
      if(index >= arr.length)
      {
        return;
      }

      arr[index].deleteC = true;

      // this.delay_del_enter = setTimeout(() => {
      //   let arr = this.upDownArr;
      //   arr[index].deleteC = true;
      // }, 1000);

    },
     // 移出
    deleteleave() {
      //clearTimeout(this.delay_del_enter);
    },
    // 移入
    enter(index) {
     
      console.log('enter',index)
      clearTimeout(time); //清除
      clearTimeout(this.delay_enter);
      clearTimeout(this.delay_move); //首先清除计时器

      //arr[index].deleteC = true;
      this.delay_enter =  setTimeout(() => {
        let arr = this.upDownArr;
        let t = 0;

        if(index >= arr.length)
        {
          return;
        }

        arr[index].deleteC = true;
    
        let arr2 = arr.filter((item) => {
          if (item.break == 1) {
            return item;
          }
        });

        if (arr2.length == 0) {
          for (let i = 0; i < index + 1; i++) {
            arr[i].move = true;
            arr[i].srot = i + 1;
            //this.imgTip = "双击分隔作品";
            this.imgTip = " 双击将这" +  arr[i].srot + "张图片分隔为一个作品";
          }
        } else {
          for (let i = 0; i < arr.length; i++) {
            ++t;
            if (arr[i].break == 1 && i != index) {
              t = 0;
            } else {
              if (i == index) {
                if (arr[index].break == 1) {
                  if (arr[index + 1] && arr[index + 1].projectName != "") {
                    this.imgTip = "双击将两个作品合并为一个";
                    let n = 0;
                    for (let q = index + 1; q < arr.length; q++) {
                      ++n;
                      if (arr[q].break == 1) {
                        let j = index - t + 1;
                        let s = 0;
                        for (let k = j; k <= index + n; k++) {
                          ++s;
                          arr[k].move = true;
                          arr[k].srot = s;
                        }

                        break;
                      }
                    }
                  } else {
                    this.imgTip = "双击取消分隔";
                    let j = index - t + 1;
                    let s = 0;
                    for (let k = j; k <= index; k++) {
                      ++s;
                      arr[k].move = true;
                      arr[k].srot = s;
                    }

                    break;
                  }
                } else {

                  let j = index - t + 1;
                  let s = 0;
                  for (let k = j; k <= index; k++) {
                    ++s;
                    arr[k].move = true;
                    arr[k].srot = s;
                  }

                  if (arr[index].projectName != "") {
                    this.imgTip = "双击将一个作品拆分为两个";
                  } else {
                    //this.imgTip = "双击分隔作品";
                    this.imgTip = " 双击将这" +  arr[i].srot + "张图片分隔为一个作品";
                  }
                  break;
                }
              }
            }
          }
        }
      }, 300);
      //console.log('aaaaaa1',this.delay_enter);
    },

    // 移出
    leave() {
      clearTimeout(time); //清除
      clearTimeout(this.delay_enter);
      clearTimeout(this.delay_move);
      //console.log('aaaaaa2',this.delay_enter);
      this.upDownArr.forEach((item) => {
        item.move = false;
        item.srot = 0;
        item.deleteC = false;
      });
    },

    // 分隔图片组成项目
    breakUp(index) {
      clearTimeout(time); //清除
      clearTimeout(this.delay_enter);
      clearTimeout(this.delay_move); //首先清除计时器

      //console.log('aaaaaa3',this.delay_enter);
      var arr = this.upDownArr;
      var axios = this.axiosArr.length;
      var that = this;
      this.clickIndex = index;
      if (that.upDownArr[index].break == 1) {
        if (this.imgTip == "双击取消分隔") {
          that.tipShow = true;
          that.tipType = false;
          that.tipMessage = "取消成功";
          setTimeout(() => {
            that.tipShow = false; 
          }, 1000);

          //双击合并时，不立即出现蒙层，做个延迟
          that.isNotShowBg = true;

          setTimeout(() => {
            that.isNotShowBg = false;
          }, 3000);

        } else if (this.imgTip == "双击将两个作品合并为一个") {
          that.tipShow = true;
          that.tipType = true;
          that.tipMessage = "合并成功";
          setTimeout(() => {
            that.tipShow = false;
          }, 1000);

          //双击合并时，不立即出现蒙层，做个延迟
          that.isNotShowBg = true;

          setTimeout(() => {
            that.isNotShowBg = false;
          }, 3000);
        }
        Vue.set(this.upDownArr[index], "break", 0);
        Vue.set(this.upDownArr[index], "projectName", null);
        this.dealWith();
        this.func1();
        this.enter(index);
      } else {
        let arr2 = arr.filter((item) => {
          if (item.upLoadStatus == -1) {
            return item;
          }
        });

        if (arr2.length == 0) {
          this.inputName = true;
          this.$nextTick(() => {
            this.$refs.projectAutofocus.focus();
          });
        } else {
          that.tipShow = true;
          that.tipType = true;
          that.tipMessage = "图片上传中，请稍候";
          setTimeout(() => {
            that.tipShow = false;
          }, 1000);
        }
      }

      this.imgMobile = false
    },

    // 打开swiper
    openSwiper(index) {

      console.log('openSwiper',index);
      var that = this;
      this.swiperHeight = `700px`;
      clearTimeout(time); //首先清除计时器
      clearTimeout(this.delay_move); //首先清除计时器

      time = setTimeout(() => {

        if(index >= that.upDownArr.length ||
         that.upDownArr[index].upLoadStatus != 1) {
          return;
        }

        this.$refs.remarkCarusel.setActiveItem(index);
        this.current = index;
        this.scrollAddress();
        this.previewImg = true;

        this.imgMobile = false
        this.dropShow = false;
      }, 200);
    },

    // 双击删除
    deleteProject(index) {
      Vue.set(this.upDownArr[index], "break", 0);
      Vue.set(this.upDownArr[index], "projectName", null);
      this.dealWith();
      this.func1();
    },

    // 获取项目名称
    submitBtn() {
      var that = this;
      const rawName = contentTitle.hasName(this.projectName) ? this.projectName : "";
      const projectName = contentTitle.work(rawName);

      let len = this.stringValidation(projectName);
      if (len > 32) {
        that.tipShow = true;
        that.tipType = false;
        that.tipMessage =
          "限16个汉字或32个字符";
        setTimeout(() => {
          that.tipShow = false;
        }, 1000);
      } else {
        this.btnRed = false;

        const reviewVersion = (this._nameReviewVersion || 0) + 1;
        this._nameReviewVersion = reviewVersion;
        const review = rawName ? wordcheck({ word: rawName }) : Promise.resolve({ status: 204 });
        review.then((res) => {
          if (this._nameReviewVersion !== reviewVersion || !this.inputName || (contentTitle.hasName(this.projectName) ? this.projectName : "") !== rawName) return;
          if (res && res.status >= 200 && res.status < 300) {
            var index = this.clickIndex;
            Vue.set(this.upDownArr[index], "projectName", projectName);
            Vue.set(this.upDownArr[index], "projectRawName", rawName);
            Vue.set(this.upDownArr[index], "break", 1);
            console.log(this.upDownArr[index], this.imgTip);
            // if (this.imgTip == "双击分隔作品") {
              if (this.imgTip.indexOf("图片分隔为作品") >= 0) {
              that.tipShow = true;
              that.tipType = true;
              that.tipMessage = "分隔成功";
              setTimeout(() => {
                that.tipShow = false;
              }, 1000);
            } else if (this.imgTip == "双击将一个作品拆分为两个") {
              that.tipShow = true;
              that.tipType = true;
              that.tipMessage = "拆分成功";
              setTimeout(() => {
                that.tipShow = false;
              }, 1000);
            }

            this.inputName = false;
            this.projectName = "";
            this.dealWith();
            this.func1();
          } else {
            that.tipShow = true;
            that.tipType = false;
            // that.tipMessage = "作品名称未通过监管审核";
            that.tipMessage = "未通过监管审核";
            setTimeout(() => {
              that.tipShow = false;
            }, 1000);
          }
        });
      }
    },

    closeMask() {
      this._nameReviewVersion = (this._nameReviewVersion || 0) + 1;
      this.inputName = false;
      this.projectName = null;
    },

    //处理数组
    dealWith() {
      var arr = this.upDownArr;

      // 处理名字
      let a = 0;
      this.upDownArr.forEach((item, idx) => {
        a++;
        if (item.break == 1) {
          let idx2 = idx + 1 - a;
          for (let q = idx2; q < idx; q++) {
            arr[q].projectName = item.projectName;
          }
          a = 0;
        } else {
          item.projectName = "";
        }
      });

      // 截取项目
      this.axiosArr = [];
      let t = 0;
      let s = 0;

      for (let i = 0; i < arr.length; i++) {
        ++t;
        if (arr[i].break == 1) {
          this.axiosArr.push({
            arr: arr.slice(s, i + 1),
            project: Object.prototype.hasOwnProperty.call(arr[i], "projectRawName") ? arr[i].projectRawName : arr[i].projectName,
          });
          arr[i].projectIndex = this.axiosArr.length;
          s = i + 1;
          console.log(this.axiosArr, "this.axiosArr");
          this.backupData = this.upDownArr;
        }
      }

      console.log(this.axiosArr, "this.axiosArr");
    },

    pleClick() {},

    // 请求接口
    getHost() {
      console.log("223");
      var that = this;
      var data = this.axiosArr;
      let t = 0;

      let arr = data.filter((item) => {
        if (item.arr.length > 20) {
          return item;
        }
      });

      if (arr.length == 0) {

        if(that.loading)
        {
          return
        }

        that.loading = true;
        that.transparentMask = true;
        that.axiosData(0);
      } else {
        this.submitMask = true;
      }
    },
    // 继续同步
    continueSubmit() {
      if (this.loading) return;
      this.loading = true;
      this.axiosData(0);
      this.submitMask = false;
      this.transparentMask = true;
    },

    // 重新整理
    againCreat() {
      this.submitMask = false;
    },
    // 请求接口
    axiosData(i) {
      if (i === 0) this.notificationWorkIds = [];
      let that = this;
      let data = this.axiosArr;
      let upDownArr = this.upDownArr;

      let params = {};
      params.sources = [];
      let dataPro = {};
      console.log(data, "data");
      dataPro.name = data[i].project;
      //item.projectName

      for (let j = 0; j < data[i].arr.length; j++) {
        let image_ave;
        if (data[i].arr[j].imageAve) {
          image_ave = data[i].arr[j].imageAve.RGB;
        } else {
          image_ave = "0xffffff";
        }
        console.log(data[i].arr[j].imageAve, i, j);
        params.sources.push({
          key: data[i].arr[j].key,
          origin: "system",
          //type_id: data[i].arr[j].type == "image" ? 1 : 2,
          type_id: 1,
          imageAve: image_ave,
          width: data[i].arr[j].width || 0,
          height: data[i].arr[j].height || 0,
          exif: data[i].arr[j].exif || '',
          avinfo: data[i].arr[j].avinfo || '',
          fsize: data[i].arr[j].fsize || 0,
          url: "https://file.zuopin.cloud/" + data[i].arr[j].key,
          file_name:data[i].arr[j].name,
        });
      }

      addPhotographerWork(dataPro).then((res) => {
        console.log('test111',res)
        if (res && res.status >= 200 && res.status < 300 && res.data && res.data.data && res.data.data.photographer_work_id) {
          params.photographer_work_id = res.data.data.photographer_work_id
          console.log('test22',params)
          addPhotographerWorkSource(params).then((res) => {
            if (!res || res.status < 200 || res.status >= 300) {
              console.log(res);
              that.tipShow = true;
              that.tipType = false;
              let message = res && res.data && res.data.message
              if(res && res.data && res.data.errors && res.data.errors.name && res.data.errors.name.length > 0){
                message = res.data.errors.name[0]
              }
              that.tipMessage =
              message || "清除浏览器历史记录后再试";
              //alert(res.data.errors);
              setTimeout(() => {
                that.tipShow = false;
              }, 1000);
              that.loading = false;
              that.transparentMask = false;
              // if (i == data.length - 1) {
              //   that.syncMask = true;
              //   that.transparentMask = false;
              // }
            } else {
              that.notificationWorkIds.push(params.photographer_work_id);
              if (i == data.length - 1) {
                that.loading = false;
                that.syncMask = true;
                that.transparentMask = false;
                sendPhotographerWorkInfo({
                  work_num: data.length,
                  source_num: data.reduce((total, item) => total + item.arr.length, 0),
                  work_ids: that.notificationWorkIds.slice(),
                }).then((res) => {
                  console.log(res, "res");
                });


              } else {
                that.axiosData(i + 1);
              }
            }
          });
        } else {
          that.tipShow = true;
          that.tipType = false;
          that.tipMessage = res && res.data && res.data.moderation ? "未通过监管审核" : "清除浏览器历史记录后再试";
          setTimeout(() => {
            that.tipShow = false;
          }, 1000);
          that.loading = false;
          that.transparentMask = false;
        }
      });
    },
    pathToTree(input) {
      var output = [];
      for (var i = 0; i < input.length; i++) {
        var chain = input[i].path.split("/");
        var currentNode = output;
        for (var j = 0; j < chain.length; j++) {
          if (chain[j] === "") {
            break;
          }
          var wantedNode = chain[j];

          var lastNode = currentNode;

          for (var k = 0; k < currentNode.length; k++) {
            if (currentNode[k].title == wantedNode) {
              currentNode = currentNode[k].children;
              break;
            }
          }
          if (lastNode == currentNode) {
            // 判断名字中是否有 .jpg/.png/等图片后缀，根据这个是判断图片，还是文件夹
            console.log(wantedNode, "wantedNode");
            if (
              wantedNode.indexOf(".jpeg") != -1 ||
              wantedNode.indexOf(".jpg") != -1 ||
              wantedNode.indexOf(".png") != -1 ||
              wantedNode.indexOf(".gif") != -1 ||
              wantedNode.indexOf(".webp") != -1 ||
              //wantedNode.indexOf(".tiff") != -1 ||
              //wantedNode.indexOf(".tif") != -1 ||
              wantedNode.indexOf(".bmp") != -1 ||
              wantedNode.indexOf(".helf") != -1 ||
              wantedNode.indexOf(".JPEG") != -1 ||
              wantedNode.indexOf(".JPG") != -1 ||
              wantedNode.indexOf(".PNG") != -1 ||
              wantedNode.indexOf(".GIF") != -1 ||
              wantedNode.indexOf(".WEBP") != -1 ||
              //wantedNode.indexOf(".TIFF") != -1 ||
              //wantedNode.indexOf(".TIF") != -1 ||
              wantedNode.indexOf(".BMP") != -1 ||
              wantedNode.indexOf(".HEIF") != -1
            ) {
              var newNode = (currentNode[k] = {
                key: input[i].path,
                title: wantedNode,
                children: [],
                check: 0,
                file: input[i].file,
                dir: 0,
                loading: 0,
                imgUrl: input[i].imgUrl,
              });
            } else if (wantedNode.indexOf("." != -1)) {
              var newNode = (currentNode[k] = {
                key: input[i].path,
                title: wantedNode,
                children: [],
                check: 0,
                file: input[i].file,
                dir: -1,
                loading: 0,
                imgUrl: input[i].imgUrl,
              });
            } else {
              var newNode = (currentNode[k] = {
                key: input[i].path,
                title: wantedNode,
                children: [],
                check: 0,
                file: input[i].file,
                dir: 1,
                loading: 0,
                imgUrl: input[i].imgUrl,
              });
            }

            currentNode = newNode.children;
          } else {
            delete currentNode.children;
          }
        }
      }
      return output;
    },
    beforeunloadHandler(e) {
      //this._beforeUnload_time = new Date().getTime()
      e = e || window.event
      if (e) {
        e.returnValue = '关闭提示'
      }
      return '关闭提示'
    },
    getNowDateString() {
      var date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hour = date.getHours()
      const minute = date.getMinutes()
      const second = date.getSeconds()
    
      return `${year}${month}${day}${hour}${minute}${second}`;
    },
    getKeyNum()
    {
      var range = 99 - 0;
      var rand = Math.random();
      var num = 0 + Math.round(rand * range); //四舍五

      if(num > 9){
        return num;
      }

      return '0' + num
    },
    getRandom(min, max) {
      return Math.round(Math.random() * (max - min) + min);
    },
    getCode() {
      let that = this;
      let code = '';
      for (var i = 0; i < 6; i++) {
        var type = that.getRandom(1, 3);
        switch (type) {
          case 1:
            code += String.fromCharCode(that.getRandom(48, 57));//数字
            break;
          case 2:
            code += String.fromCharCode(that.getRandom(65, 90));//大写字母
            break;
          case 3:
            code += String.fromCharCode(that.getRandom(97, 122));//小写字母
            break;
        }
      }
      return code;
    },
    imgDownload(event)
    {
      console.log('imgDownload')
      var that = this;

      this.download_status = 1;
      downloadAllImg().then(res => {
        console.log("全部图片列表",res);
        var list = res.data.data;

        that.handleDownload(list, 0);
      });
      
    },
    handleDownload(list, i)
    {
      var that = this;
        var url = list[i].url;
        var filename = list[i].key;
        var total = list.length;

        this.download_total = total
        this.download_index = i;

        if(!url || !filename)
        {
          that.handleDownload(list, i + 1);
          return
        }
        const x = new window.XMLHttpRequest();
        x.open('GET', url, true);
        x.responseType = 'blob';
        x.onload = () => {
            //let time = new Date().toLocaleDateString();
            const url = window.URL.createObjectURL(x.response);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();

            //Dolphin.notify(i + '/' + total +  '正在下载中', 'success');
            // that.tipShow = true;
            // that.tipType = true;
            // that.tipMessage = i + "/" + total +  "正在下载中";
            // setTimeout(() => {
            //   that.tipShow = false;
            // }, 1000);
            //that.$message.success(i + "/" + total +  "正在下载中");
            i = i + 1;
            if(i < total)
            {
              setTimeout(() => {
                that.handleDownload(list, i);
              }, 100);
            }
            else
            {
               setTimeout(() => {
                that.download_status = 2;
              }, 100);
            }

        };
        x.send();
    }
  },
  beforeRouteLeave(to, from, next) 
  {
    console.log('to', to);

    if(to.name && to.name == 'tab'){
      var msg = "系统可能不会保存您所做的更改。";
      if(this.userInfo.is_expire == 1 && this.userInfo.is_download == 1)
      {
        msg = "离开后无法继续下载，请确认是否下载完成";
      }
      
      this.$confirm(msg, "离开此页面？", {
        confirmButtonText: "离开",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(() => {
        // confirmButton回调
        next()
      })
      .catch(() => {
          // cancelButton回调，把当前页路由推回
          // 不能使用this.$router进行路由操作，会触发beforeRouteLeave导致死循环
          window.history.pushState("", "", this.currentUrl)
      })
    }
  },
};
</script>



<style lang="less" scoped>
.headerPo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 102;
  background: rgba(255, 255, 255, 0.95) !important;
}
.main {
  width: 90%;
  // min-width: 1300px;
  margin: auto;
  // height: calc(100vh - 60px);
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .twoView {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .blockView {
      border-radius: 10px;
      // height: 615px;
      height: 100%;
      width: 100%;
      // min-width: 400px;
      box-sizing: border-box;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      position: relative;
      .titleTwo {
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: -15px;
        p {
          font-weight: normal;
          font-size: 12px;
        }
        .addBtn {
          background: #000;
          width: 180px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          border-radius: 60px;
          font-size: 18px;
          position: relative;
          cursor: pointer;
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #fff;
            cursor: pointer;
          }
          input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            cursor: pointer;
          }
        }
      }
      .fileList {
        width: 100%;
        height: 100%;
        display: flex;
        border-radius: 10px;
        align-items: center;
        justify-content: center;
        .listNull {
          .propaganda {
            .oneTitle {
              font-size: 28px;
              line-height: 30px;
              font-weight: 600;
              margin-top: 40px;
              color: #000;
            }
            .oneTitle1 {
              font-size: 28px;
              line-height: 30px;
              font-weight: 600;
              margin-top: 10px;
              margin-bottom: 24px;
              color: #000;
            }
            p {
              margin-top: 4px;
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
            }
          }
          text-align: center;
          .imgIcon {
            width: 80px;
            height: 80px;
          }
          .addBtn {
            background: #000;
            width: 300px;
            height: 60px;
            text-align: center;
            line-height: 60px;
            border-radius: 40px;
            position: relative;
            margin: 50px auto 10px;
            cursor: pointer;
            span {
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #fff;
              cursor: pointer;
            }
            input {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0;
              cursor: pointer;
            }
          }
          .fakeInput {
            background: rgba(0, 0, 0, 1);
            border-radius: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            width: 189px;
            height: 48px;
            text-align: center;
            line-height: 48px;
            img {
              vertical-align: middle;
            }
          }
          p {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            margin-top: 16px;
          }
        }
      }
      .fileData {
        width: 100%;
        height: 94%;
        border-radius: 10px;
        .title {
          display: flex;
          justify-content: space-between;
          .tabList {
            height: 36px;
            border-radius: 18px;
            border: 1px solid rgba(227, 227, 227, 1);
            line-height: 36px;
            display: flex;
            align-items: center;
            .tabItem {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              text-align: center;
              line-height: 26px;
              height: 26px;
              padding: 0px 13px;
              box-sizing: border-box;
              margin: 0px 5px;
              border-radius: 18px;
              background: #e3e3e3;
              color: #666666;
              img {
                vertical-align: middle;
              }
            }
            .check {
              background: #000;
              color: rgba(255, 255, 255, 1);
            }
          }
          .addDir {
            width: 122px;
            height: 36px;
            background: rgba(0, 0, 0, 1);
            border-radius: 18px;
            text-align: center;
            line-height: 36px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            position: relative;
            input {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0;
              // display:none;
            }
            input:hover {
            }
            img {
              vertical-align: middle;
              margin-right: 2px;
              width: 16px;
              height: 16px;
            }
          }
        }
        .projectDir {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-top: 16px;
          span {
            font-weight: 600;
          }
        }
        .projectList {
          height: 576px;
          overflow-y: scroll;
          margin-top: 16px;
          position: relative;
          input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
          }
          .projectItem {
            width: 84px;
            margin-right: 20px;
            margin-bottom: 20px;
            display: inline-block;
            vertical-align: top;
            .addImgBtn {
              width: 84px;
              height: 84px;
              display: flex;
              justify-content: center;
              align-items: center;
              background: rgba(229, 229, 229, 1);
              border-radius: 4px;
              position: relative;
              input {
                position: absolute;
                width: 100%;
                height: 100%;
                opacity: 0;
                left: 0;
                top: 0;
              }
            }
            .posi {
              position: relative;
              .iconCheck {
                position: absolute;
                right: 8px;
                top: 8px;
                width: 18px;
                height: 18px;
              }
              .loadDiv {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #ffffff;
                border-radius: 4px;
                background: rgba(0, 0, 0, 0.6);
                z-index: 999;
                font-size: 12px;
              }
            }
            .fileIcon {
              width: 84px;
              height: 84px;
              display: flex;
              justify-content: center;
              align-items: center;
              background: rgba(229, 229, 229, 1);
              border-radius: 4px;
              img {
                width: 28px;
                height: 25px;
              }
            }
            .imgType {
              width: 84px;
              height: 84px;
              border-radius: 4px;
              vertical-align: top;
              object-fit: cover;
            }
            p {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              text-align: center;
              margin-top: 6px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
        .thumbnailTab {
          width: 100%;
          height: 45px;
          background: rgba(245, 245, 245, 1);
          border-radius: 0px 0px 10px 10px;
          position: absolute;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          img {
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 5px;
          }
        }
      }
      .div12 {
        overflow: hidden;
        .upFileData {
          width: 100%;
          display: flex;
          flex-direction: row;
          align-content:flex-start;
          flex-wrap:wrap;
          overflow-y: scroll;
          box-sizing: border-box;
          padding-bottom: 100px;
          padding-top: 100px;
          scrollbar-width: none;
          height: 100vh;
          .upLoadItem {
            display: inline-block;
            padding-right: 16px;
            padding-bottom: 30px;
            height: 126px;
            vertical-align: top;
            .upLoadImg {
              // width: 120px;
              height: 120px;
              border-radius: 10px;
              position: relative;
              background: rgba(0, 0, 0, 0.05);
              //background: #fff;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              cursor: pointer;
              .imgHalfMask {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 50%;
                background: linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                font-size: 10px;
                padding: 5px 8px;
                box-sizing: border-box;
                color: #fff;
                font-weight: normal;
                // opacity: 0.8;
                .name {
                  width: 75px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  margin-top: 3px;
                }
                .right {
                  position: absolute;
                  right: 5px;
                  top: 38px;
                  width: 40px;
                  height: 40px;
                }
              }
              .closeIcon {
                width: 16px;
                height: 16px;
                position: absolute;
                top: 8px;
                right: 6px;
                z-index: 200;
              }
              .image {
                // max-width: 120px;
                max-height: 120px;
                border-radius: 10px;
                object-fit: cover;
              }

              .image-e {
                // max-width: 120px;
                // max-height: 120px;
                height: 120px;
                width: 120px;
                border-radius: 10px;
              }

              .bg {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 10px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background: rgba(0, 0, 0, 0.9);
                z-index: 99;
                font-size: 30px;
                .shapeImg {
                  font-size: 20px;
                  position: absolute;
                  left: 5px;
                  top: 5px;
                  width: 70px;
                  height: 20px;
                  opacity: 0.5;
                }
              }

              .bg-1{

              }

              .maskImgerr {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 10px;
                background: rgba(214, 49, 49, 0.8);
                font-size: 12px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                z-index: 100;
                .errIcon {
                  width: 24px;
                  height: 21px;
                  margin-top: 16px;
                  margin-bottom: 6px;
                }
              }
              .maskImgIng {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 10px;
                background: rgba(0, 0, 0, 0);
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                .el-progress {
                  /deep/ .el-progress-circle {
                    width: 60px !important;
                    height: 60px !important;
                    /deep/ svg path:first-child {
                      stroke: #dddddd;
                    }
                  }
                  /deep/ .el-progress__text {
                    color: #000000;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 400;
                  }
                }
              }
              .projectI {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -20px;
                margin-left: -20px;
                width: 40px;
                height: 40px;
                border-radius: 100%;
                background: rgba(0, 0, 0, 0.6);
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                text-align: center;
                line-height: 40px;
                z-index: 100;
                // .right{
                //   width: 15px;
                //   height: 15px;
                //   vertical-align: middle;

                // }
              }

            }
            .item-name{
                  height: 40px;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  margin-top: 6px;
                  font-weight: normal;
                  font-size: 6px;
                }

            .upLoadItem_bg1{
              // background: #fff;
              background:rgba(255,255,255, 0)
            }

          }
          .c1 {
            border-right: 2px solid #000;
          }
        }
      }
    }
    .cloudFile {
      position: relative;
      input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }

  .oneView {
    width: 100%;
    min-width: 1000px;
    height: 85vh;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 10px;
    border: 1px solid rgba(221, 221, 221, 1);
    .viewTitle {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      img {
        margin-right: 4px;
      }
      .placeholderStyle {
        display: flex;
        justify-content: space-between;
        .currentDir {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    .oneViewNull {
      width: 100%;
      height: 94%;
      border: 1px dashed #000;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .contantNull {
        text-align: center;
        .fakeBtn {
          background: rgba(0, 0, 0, 1);
          border-radius: 24px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          width: 189px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          margin: 0px auto 20px;
          position: relative;
          img {
            vertical-align: middle;
          }
        }
        p {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
  }
}

.footer {
  position: fixed;
  bottom: 30px;
  left: 8.5%;
  width: 80%;
  // min-width: 1000px;
  height: 60px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  padding: 0px 10px;
  border-radius: 30px;
  z-index: 101;
  animation: water-wave linear infinite;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: start;
  .conterDiv {
    width: 50%;
    // min-width: 800px;
    margin: auto;
    height: 60px;
    font-size: 12px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    .saveToXcx {
      width: 160px;
      height: 40px;
      background: #000;
      border-radius: 40px;
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column-reverse;
      z-index: 999;
      margin-left: 20px;
      cursor: pointer;
      .xcxP1 {
        font-size: 16px;
      }
      .xcxP2 {
        font-size: 16px;
      }
    }

    .saveToXcxs {
      width: 150px;
      height: 40px;
      background: #000;
      border-radius: 40px;
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column-reverse;
      z-index: 999;
      margin-left: 20px;
      cursor: pointer;
      .xcxP2 {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
      }
    }

    .agoAdd {
      height: 100%;
      margin-right: 10px;
      font-size: 15px;
      font-weight: 400;
      color: #0072FF;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      span{
        cursor: pointer;  
      }
      input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
      }
    }

    .pNum {
      span {
        margin-right: 15px;
      }
    }
  }
  .progressDiv {
    position: absolute;
    top: -500px;
    background: #3ecdf6;
    height: 1200px;
    width: 1200px;
    border-radius: 40%;
    animation: inherit;
    animation-duration: 4s;
  }
  .leftProess {
    width: 100%;
    height: 100%;
    font-size: 20px;
    padding-left: 40px;
    font-weight: 600;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    .jindu{
      width:70px;
      line-height: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
    .pNum {
      height: 100%;
      font-size: 15px;
      margin-bottom: 2px;
      display: inline-block;
      margin-left: 40px;
      font-weight: normal;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
}

.syncMask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  .syncSuccess {
    width: 420px;
    height: 500px;
    background: #fff;
    border-radius: 20px;
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .qrcode {
      width: 200px;
      height: 200px;
      padding-top: 15px;
      object-fit: cover;
    }
    .tip {
      font-size: 15px;
      text-align: center;
      margin-top: 20px;
    }
    .continue {
      height: 60px;
      line-height: 60px;
      background: #000;
      color: #fff;
      text-align: center;
      justify-content: center;
      position: relative;
      border-radius: 60px;
      font-size: 18px;
      font-family: PingFang SC;
      cursor: pointer;
      input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
      }
    }
    .returnBtn {
      height: 60px;
      line-height: 60px;
      background: rgba(0,0,0,0.05);
      text-align: center;
      justify-content: center;
      border-radius: 60px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0,0,0,0.6);
      font-size: 18px;
      cursor: pointer;
    }
  }
  .outMask {
    width: 420px;
    height: 300px;
    background: #fff;
    border-radius: 20px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 20px;
    .outClose {
      position:absolute;
      right: 20px;
      top: 30px;
      img {
        width: 14px;
        height: 14px;
      }
    }
    .titleP {
      font-size: 22px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 800;
      color: rgba(0, 0, 0, 1);
      line-height: 30px;
      // text-align: center;
      text-align: left;
      margin-top: 0px;
    }
    .titleG {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 24px;
      margin-top: 8px;
      color: rgba(0, 0, 0, 0.4);
      // text-align: center;
      text-align: left;
    }
    .btnMoni {
      .noOut {
        height: 60px;
        border-radius: 60px;
        background: rgba(0, 0, 0);
        text-align: center;
        justify-content: center;
        line-height: 60px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255);
        cursor: pointer;
      }
      .okOut {
        height: 60px;
        border-radius: 60px;
        background: rgba(0, 0, 0, 0.05);
        text-align: center;
        justify-content: center;
        line-height: 60px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
        cursor: pointer;
      }
    }
  }
}

.maskOut {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  .outMask {
    width: 420px;
    height: 260px;
    background: #fff;
    border-radius: 20px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 20px;
    .outClose {
      position:absolute;
      right: 20px;
      top: 30px;
      img {
        width: 14px;
        height: 14px;
      }
    }
    .titleP {
      font-size: 22px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 800;
      color: rgba(0, 0, 0, 1);
      line-height: 30px;
      // text-align: center;
      text-align: left;
      margin-top: 0px;
    }
    .titleG {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 24px;
      margin-top: 8px;
      color: rgba(0, 0, 0, 0.4);
      // text-align: center;
      text-align: left;
    }
    .btnMoni {
      .noOut {
        height: 60px;
        border-radius: 60px;
        background: rgba(0, 0, 0, 1);
        text-align: center;
        justify-content: center;
        line-height: 60px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        cursor: pointer;
      }
      .okOut {
        height: 60px;
        border-radius: 60px;
        background: rgba(0, 0, 0, 0.05);
        text-align: center;
        justify-content: center;
        line-height: 60px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
        cursor: pointer;
      }
    }
  }
}

.bigMask {
  position: fixed;
  background: rgba(255, 255, 255, 0.8);
  border: 3px dashed rgb(204, 204, 204);
  z-index: 10000;
  color: rgb(0, 0, 0);
  font-size: 40px;
  text-align: center;
  overflow: hidden;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  padding-top: 20%;
  box-sizing: border-box;
  display: none;
  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  p {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -160px;
    width: 320px;
  }
}

.videoMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .videoView {
    width: 900px;
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    background: #000;

    video {
      object-fit: fill;
      border-radius: 10px;
      z-index: -1;
    }
    video:focus {
      outline: none;
    }
  }
  .videoUpMask {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 9999;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    padding: 20px;
    box-sizing: border-box;
    .closeView {
      position: absolute;
      right: 220px;
      top: 80px;
      cursor: pointer;
      z-index: 9999;
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
}

.maskSwiper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 1000 !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .closeView {
    position: absolute;
    right: 30px;
    top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    .nnnno {
      width: 45px;
      height: 45px;
    }
  }

  .swiperContant {
    width: calc(100vw - 52px);
    height: 100%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .swiperBtn {
      .swiperIcon {
        width: 50px;
        height: 50px;
      }
    }
    .swiperImg {
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      width: 705px;
      height: 600px;
      position: relative;
      .swiperItem {
        width: 700px;
        height: 520px;
        margin: 25px 0px 50px;
        position: relative;
        display: table-cell;
        vertical-align: middle;
        .qiniuImg {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          // border-radius: 10px;
          margin-top: 10px;
        }
        .saveImage {
          position: absolute;
          width: 100px;
          height: 30px;
          border-radius: 20px;
          border: 1px solid #fff;
          background: rgba(0, 0, 0, 0.3);
          text-align: center;
          line-height: 30px;
          bottom: 16px;
          left: 50%;
          margin-left: -50px;
        }
        .loading {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #fff;
          border-radius: 20px;
          text-align: center;
          line-height: 2;
          font-size: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          .loadImg {
            margin: 0px;
            width: 40px;
            height: 40px;
          }
        }
      }

      .swiperList {
        // width: 100vw;
        height: 80px;
        display: -webkit-box;
        // overflow-x: scroll;
        overflow-y: hidden;
        position: fixed;
        left: calc(50vw - 43px);
        bottom: 0px;
        padding: 0px 8px 16px;
        .conterDiv {
          display: flex;
          justify-content: center;
          align-items: center;
          .thumbnail {
            margin-right: 14px;
            border-radius: 14px;
            width: 72px;
            height: 72px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 10px;
              display: block;
              font-size: 0;
            }
            .indicator {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: #fff;
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              .littleLoad {
                margin: 0px;
                width: 20px;
                height: 20px;
              }
            }
          }
          .check {
            border: 4px solid #ffffff;
            background: #ffffff;
          }
        }
      }

      .swiperList::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .projectName {
    width: 420px;
    height: 260px;
    background: #fff;
    border-radius: 20px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 20px;
    .title {
      // padding: 10px 15px 20px;
      box-sizing: border-box;
      display: flex;
      justify-content:space-between;
      align-items: flex-start;
      .title_text {
        display: flex;
        flex-direction: column;
        justify-content: left;
        .title_1 {
          font-size:22px;
          font-weight: 800;
          line-height: 30px;
          color: rgba(0, 0, 0, 1);
        }
        .title_2 {
          font-size:16px;
          font-weight: 400;
          line-height: 24px;
          margin-top: 8px;
          color: rgba(0, 0, 0, 0.4);
        }
      }
    }
    .proItem {
      // width: 436px;
      // margin: auto;
      // margin-top: 40px;
      // padding: 0px 15px;
      .projectFormItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // margin-bottom: 18.2px;

        p {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .formItem {
          width: 100%;
          display: flex;
          justify-content: space-between;
          .inputBg {
            width: 100%;
            height: 60px;
            border-radius: 30px;
            background: rgba(0, 0, 0, 0.05);
            line-height: 60px;
            font-size: 16px;
            input {
              border: none;
              margin-left: 20px;
              width: 90%;
              font-size: 16px;
              background: rgba(0, 0, 0, 0.0);
            }
            input:focus {
              outline: none;
            }
            input::-webkit-input-placeholder {
              font-size: 16px;
              background: rgba(0, 0, 0, 0.0);
              color:rgba(0, 0, 0, 0.2)

            }
            span {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.2);
              float: right;
              margin-right: 15px;
            }
          }
          .downDrop {
            width: 153px;
            height: 44px;
            background: rgba(0, 0, 0, 0.05);
            border-radius: 22px;
            line-height: 44px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0px 14px 0px 20px;
            box-sizing: border-box;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }
          .placeholderStyle {
            color: rgba(0, 0, 0, 0.2);
          }
          .formItemTip {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            text-align: center;
            display: flex;
            align-items: center;
            span {
              text-align: top;
              margin-left: 4px;
            }
          }
          .pretentBtn {
            width: 77px;
            height: 26px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            background: rgba(0, 0, 0, 1);
            border-radius: 22px;
            text-align: center;
            line-height: 26px;
            margin: 0px 16px;
          }
          .baiduName {
            margin-left: 24px;
            margin-right: 24px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            text-align: center;
          }
        }
      }
    }

    .elInput {
      width: 400px;
      margin: 10px 30px;
    }
    .submitBtn {
      // width: 110px;
      height: 60px;
      border-radius: 60px;
      background: #000;
      color: #fff;
      line-height: 60px;
      // margin: 40px auto;
      font-size: 18px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.inputFileStyle {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}

.tuozhuai {
  // background: red;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}

.loads {
  animation: animal 1s steps(12, end) infinite;
  -webkit-animation: animal 1s steps(12, end) infinite;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  width: 26px;
  height: 26px;
  vertical-align: middle;
  margin-right: 12px;
}

@keyframes water-wave {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes animal {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes animal {
  0% {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  opacity: 0;
}







.bg9 {
  background: rgba(0, 0, 0, 0.9);
}

.transparentMask {
  position: fixed;
  bottom: 0;
  left: 0;
  background: rgb(0, 0, 0, 0.7);
  width: 100vw;
  height: 100vh;
  z-index: 100 !important;
  opacity: 0.9;
}
</style>

<style lang="less">
// 双击取消分隔
.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
  border-top-color: #ec4d3d;
}
.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: #ec4d3d;
}
.atooltip {
  background: #ec4d3d !important;
  font-family: PingFang SC;
}

// 双击合并项目/双击分隔项目/双击创建项目
.merge.el-tooltip__popper[x-placement^="top"] .popper__arrow {
  border-top-color: #0072FF;
}
.merge.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: #0072FF;
}
.merge {
  background: #0072FF !important;
  font-family: PingFang SC;
}

.familyClass {
  font-family: PingFang SC;
}

.el-carousel__container {
  position: relative;
  height: 540px !important;
}

:focus {
  outline: 0 !important;
}
</style>